import classNames from 'classnames';
import { FC, memo } from 'react';

import { RouteProps } from '../../types/route';
import { isExternalRoute, isRoutePath } from '../../utils/route';
import { router } from '../Router';
import ExternalRoute from './ExternalRoute';
import InternalRoute from './InternalRoute';

const Index: FC<RouteProps> = ({
  children,
  className,
  hash,
  href,
  sx,
  underline = true,
  variant = 'body1',
  whiteSpace = 'nowrap',
  ...props
}) => {
  sx = { ...sx, whiteSpace };

  if (!underline) className = classNames(className, 'no-underline');

  if (isExternalRoute(href)) {
    return (
      <ExternalRoute {...props} className={className} href={href} sx={sx} variant={variant}>
        {children}
      </ExternalRoute>
    );
  }

  if (isRoutePath(href)) {
    return router.isRegisteredRoute(href) ? (
      <InternalRoute
        {...props}
        className={className}
        hash={hash}
        href={href}
        sx={sx}
        variant={variant}
      >
        {children}
      </InternalRoute>
    ) : (
      // route exists but not in this app
      <>{children}</>
    );
  }

  throw new Error(`Route "${href}" does not exist!`);
};

export default memo(Index);
